/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Relation from './relation';
import RelationDetail from './relation-detail';
import RelationUpdate from './relation-update';
import RelationDeleteDialog from './relation-delete-dialog';

const RelationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Relation />} />
    <Route path="new" element={<RelationUpdate />} />
    <Route path=":id">
      <Route index element={<RelationDetail />} />
      <Route path="edit" element={<RelationUpdate />} />
      <Route path="delete" element={<RelationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RelationRoutes;
